import React, { useEffect, useRef, useState } from "react";
import { TRUSTED_BUSINESSES } from "../data/trustedBusinesses";
import "./TrustedBusinesses.css";

const VISIBLE = 6;
const SWAP_MS = 2400;
const FADE_MS = 320;

function prefersReducedMotion() {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export default function TrustedBusinesses({
  variant = "light",
  showHeading = true,
  visibleCount = VISIBLE,
}) {
  const names = TRUSTED_BUSINESSES;
  const count = Math.min(visibleCount, names.length);
  const [slots, setSlots] = useState(() => names.slice(0, count));
  const [fading, setFading] = useState(-1);
  const queueRef = useRef(names.slice(count));
  const tickRef = useRef(0);
  const fadeTimer = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (prefersReducedMotion() || names.length <= count) return undefined;

    intervalRef.current = setInterval(() => {
      const slot = tickRef.current % count;
      tickRef.current += 1;
      setFading(slot);
      if (fadeTimer.current) clearTimeout(fadeTimer.current);
      fadeTimer.current = setTimeout(() => {
        setSlots((current) => {
          const next = current.slice();
          const pool = queueRef.current.slice();
          if (pool.length === 0) {
            const other = (slot + 1 + (tickRef.current % (count - 1))) % count;
            const tmp = next[slot];
            next[slot] = next[other];
            next[other] = tmp;
            return next;
          }
          const incoming = pool.shift();
          pool.push(next[slot]);
          queueRef.current = pool;
          next[slot] = incoming;
          return next;
        });
        setFading(-1);
      }, FADE_MS);
    }, SWAP_MS);

    return () => {
      clearInterval(intervalRef.current);
      if (fadeTimer.current) clearTimeout(fadeTimer.current);
    };
  }, [count, names.length]);

  return (
    <div className={`qt-trusted qt-trusted--${variant}`}>
      {showHeading ? (
        <p className="qt-trusted__label">Trusted by South African businesses</p>
      ) : null}
      <ul className="qt-trusted__list" aria-live="off">
        {slots.map((brand, index) => (
          <li
            key={index}
            className={
              fading === index
                ? "qt-trusted__item qt-trusted__item--out"
                : "qt-trusted__item"
            }
            style={{ "--brand": brand.color }}
          >
            {brand.name}
          </li>
        ))}
      </ul>
    </div>
  );
}
